module.exports = __webpack_public_path__ + "img/tartinevert_off.7746b4a6.gif";